"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _r10CommonComponents = require("r10-common-components");
var _jsonpath = _interopRequireDefault(require("jsonpath"));
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _useConfig3 = _interopRequireDefault(require("../hooks/useConfig"));
var _useTranslation = _interopRequireDefault(require("../hooks/useTranslation"));
var _selector = require("../selectors/selector");
var _Actions = require("../actions/Actions");
var _appConstants = require("../appConstants");
var _useOtherWidgetState2 = _interopRequireDefault(require("../hooks/useOtherWidgetState"));
var _useProps2 = _interopRequireDefault(require("../hooks/useProps"));
var _formatSectionType = _interopRequireDefault(require("../utils/formatSectionType"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /* eslint-disable max-len */
var getDate = function getDate(item, bundleData, t) {
  var value = item.jsonPath ? _jsonpath.default.query(bundleData, item.jsonPath) : [];
  if (item.fallbackPath && !value.length) {
    value = _jsonpath.default.query(bundleData, item.fallbackPath);
  }
  return (0, _formatSectionType.default)(value, item.type, t);
};
var getPrice = function getPrice(item, bundleData, t) {
  var value = item.jsonPath ? _jsonpath.default.query(bundleData, item.jsonPath) : [];
  return {
    value: value[0],
    formattedValue: (0, _formatSectionType.default)(value, item.type, t)
  };
};
var getTypes = function getTypes(item, bundleData) {
  var autoRenew = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var types = item !== null && item !== void 0 && item.jsonPath ? _jsonpath.default.query(bundleData, item.jsonPath) : [];
  if (!types.length) return 'adhoc';
  if (types.length === 1) return types[0];
  return !autoRenew ? 'adhoc' : types.includes('recurring') ? 'recurring' : 'service';
};
var BuyAddonModal = function BuyAddonModal(_ref) {
  var isModalOpen = _ref.isModalOpen,
    setIsModalOpen = _ref.setIsModalOpen,
    bundleDetails = _ref.bundleDetails,
    bundleName = _ref.bundleName,
    bundleId = _ref.bundleId,
    autoRenew = _ref.autoRenew;
  var history = (0, _reactRouterDom.useHistory)();
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useProps = (0, _useProps2.default)(),
    genericActionsWidget = _useProps.genericActionsWidget,
    topUpWidget = _useProps.topUpWidget;
  var _useConfig = (0, _useConfig3.default)(),
    productOrderEndPoint = _useConfig.productOrderEndPoint,
    purchaseFlowErrorHandling = _useConfig.purchaseFlowErrorHandling;
  var currentScreen = (0, _reactRedux.useSelector)(_selector.getCurrentScreen);
  var phoneNumber = (0, _reactRedux.useSelector)(_selector.getPhoneNumber);
  var primaryDealerCode = (0, _reactRedux.useSelector)(_selector.getPrimaryDealerCode);
  var agentName = (0, _reactRedux.useSelector)(_selector.getAgentName);
  var taxPercentage = (0, _reactRedux.useSelector)(function (state) {
    return (0, _selector.getTaxPercentage)(state, topUpWidget);
  });
  var dateFormat = (0, _reactRedux.useSelector)(_selector.dateFormatSelector);
  var t = (0, _useTranslation.default)();
  var today = _r10CommonComponents.utils.formatDate(new Date().toISOString(), dateFormat);
  var _useConfig2 = (0, _useConfig3.default)(),
    summarySection = _useConfig2.summarySection,
    successScreenRedirectUrl = _useConfig2.successScreenRedirectUrl;
  var duration = getDate(summarySection.find(function (s) {
    return s.type === 'date';
  }), bundleDetails, t);
  var price = getPrice(summarySection.find(function (s) {
    return s.type === 'money';
  }), bundleDetails, t);
  var _useOtherWidgetState = (0, _useOtherWidgetState2.default)(genericActionsWidget, 'customerBalance'),
    currentFormattedBalance = _useOtherWidgetState.formattedValue,
    currentBalance = _useOtherWidgetState.amount;
  var requiredTopUpAmount = Math.ceil((price.value.value - currentBalance) * ((100 + taxPercentage) / 100));
  var buyAddonHandler = function buyAddonHandler() {
    var payload = {
      productOrderItem: [{
        action: getTypes(summarySection.find(function (s) {
          return s.type === 'type';
        }), bundleDetails, autoRenew),
        quantity: 1,
        productOffering: {
          id: bundleId
        }
      }],
      relatedParty: [{
        id: phoneNumber,
        role: 'subscriber'
      }, {
        id: agentName,
        role: 'username',
        '@referredType': 'Individual'
      }, {
        id: primaryDealerCode,
        role: 'primaryDealerCode',
        '@referredType': 'Organization'
      }]
    };
    dispatch((0, _Actions.buyAddonRequest)(payload, genericActionsWidget, productOrderEndPoint, purchaseFlowErrorHandling));
  };
  var topUpHandler = function topUpHandler() {
    setIsModalOpen(false);
    dispatch((0, _Actions.openTopup)(topUpWidget));
    dispatch((0, _Actions.updateTopUpDefaultnValue)(topUpWidget, requiredTopUpAmount));
    dispatch((0, _Actions.updateTopUpMinValue)(topUpWidget, requiredTopUpAmount));
  };
  (0, _react.useEffect)(function () {
    return function () {
      return dispatch((0, _Actions.setCurrentScreen)(_appConstants.SCREENS.confirmation));
    };
  }, [isModalOpen]);
  (0, _react.useEffect)(function () {
    if (currentBalance || currentBalance === 0) return;
    dispatch((0, _Actions.getBalanceDetailsRequest)(genericActionsWidget));
  }, []);
  var successHandler = function successHandler() {
    setIsModalOpen(false);
    /*
      This workaround is for modal not being closed after redirection.
      Invoking setTimeout with a callback, and zero as the second argument will schedule the callback to be run asynchronously, after the shortest possible delay.
    */
    setTimeout(function () {
      history.push(successScreenRedirectUrl);
    }, 0);
  };
  return /*#__PURE__*/_react.default.createElement(_r10CommonComponents.OrderAndValidationModal, {
    screens: {
      loading: {
        text: t('loadingPurchase'),
        testIds: {
          loader: 'loader-purchase'
        }
      },
      confirmation: _objectSpread(_objectSpread({
        mainConfirmationMessage: t('mainConfirmationMessagePurchase', {
          bundleName: bundleName
        }),
        subConfirmationMessage: "".concat(t('subConfirmationMessagePurchase'), " ").concat(today),
        duration: {
          icon: 'calendar-month',
          text: t('durationPurchase', {
            duration: duration
          })
        },
        priceText: t('pricePurchase', {
          price: price.formattedValue
        })
      }, currentFormattedBalance ? {
        currentBalanceText: t('currentBalancePurchase', {
          currentFormattedBalance: currentFormattedBalance
        })
      } : {}), {}, {
        button: {
          text: t('ConfirmPurchase'),
          action: buyAddonHandler
        },
        testIds: {
          mainConfirmationMessage: 'main-confirmation-message',
          subConfirmationMessage: 'sub-confirmation-message',
          durationIcon: 'duration-icon-purchase',
          durationText: 'duration-text-purchase',
          price: 'price-purchase',
          currentBalance: 'current-balance-purchase',
          button: 'confirm-button'
        }
      }),
      success: _objectSpread(_objectSpread({
        successIcon: 'tick-outline',
        mainSuccessMessage: t('mainSuccessMessage'),
        subSuccessMessage: t('subSuccessMessage', {
          bundleName: bundleName
        }),
        duration: {
          icon: 'calendar-month',
          text: t('durationPurchase', {
            duration: duration
          })
        }
      }, currentFormattedBalance ? {
        remainingBalance: t('remainingBalancePurchase', {
          currentFormattedBalance: currentFormattedBalance
        })
      } : {}), {}, {
        button: {
          text: t('successButton'),
          action: successHandler
        },
        testIds: {
          successIcon: 'success-icon',
          mainSuccessMessage: 'main-success-message',
          subSuccessMessage: 'sub-success-message',
          durationIcon: 'duration-icon-purchase',
          durationText: 'duration-text-purchase',
          remainingBalance: 'current-balance-purchase',
          button: 'view-active-addons-button'
        }
      }),
      genericError: {
        genericErrorIcon: 'warning',
        mainErrorMessage: t('mainErrorMessage'),
        subErrorMessage: t('subErrorMessage', {
          bundleName: bundleName
        }),
        thirdErrorMessage: t('thirdErrorMessage'),
        fourthErrorMessage: t('fourthErrorMessage'),
        button: {
          text: t('genericErrorButton'),
          action: buyAddonHandler
        },
        testIds: {
          genericErrorIcon: 'generic-error-icon',
          mainErrorMessage: 'main-error-message',
          subErrorMessage: 'sub-error-message',
          thirdErrorMessage: 'third-error-message',
          fourthErrorMessage: 'fourth-error-message',
          button: 'try-again-button'
        }
      },
      lowBalance: _objectSpread(_objectSpread({
        lowBalanceIcon: 'warning',
        mainErrorMessage: t('lowBalanceErrorMessage'),
        subErrorMessage: t('lowBalanceSubErrorMessage')
      }, currentFormattedBalance ? {
        availableBalanceMessage: t('availableBalanceMessage', {
          currentFormattedBalance: currentFormattedBalance
        })
      } : {}), {}, {
        requiredBalanceMessage: t('requiredBalanceMessage', {
          amount: "".concat(_r10CommonComponents.utils.formatMoney(requiredTopUpAmount, price.value.unit, true).money).concat(_r10CommonComponents.utils.formatMoney(requiredTopUpAmount, price.value.unit).currencySymbol)
        }),
        button: {
          text: t('lowBalanceButton'),
          action: topUpHandler
        },
        testIds: {
          lowBalanceIcon: 'low-balance-icon',
          mainErrorMessage: 'main-error-message',
          subErrorMessage: 'sub-error-message',
          availableBalanceMessage: 'available-balance-message',
          requiredBalanceMessage: 'required-balance-message',
          button: 'topup-now-button'
        }
      })
    },
    currentScreen: currentScreen,
    isModalOpen: isModalOpen,
    setIsModalOpen: setIsModalOpen
  });
};
BuyAddonModal.propTypes = {
  isModalOpen: _propTypes.default.bool.isRequired,
  setIsModalOpen: _propTypes.default.func.isRequired,
  bundleDetails: _propTypes.default.object,
  bundleName: _propTypes.default.string,
  autoRenew: _propTypes.default.bool,
  bundleId: _propTypes.default.string
};
var _default = BuyAddonModal;
exports.default = _default;